/**
 * URL filters for the Email Activity screen.
 *
 * The filters live in the query string so a view is shareable and
 * survives a refresh; the morning digest deep-links here with
 * `?date_from=…&date_to=…&status=bounced,dropped,spam,blocked&category=WORKFLOW,CAMPAIGN,FOLLOW_UP`.
 * Comma lists are passed to the API as-is (it splits them); the presets
 * below give them a readable entry in the Status and Type controls, so a
 * linked filter is always visible rather than hidden behind "All".
 */

export const ACTIVITY_KEYS = [
  "date_from", "date_to", "workflow_id", "campaign_id", "step_index",
  "status", "category", "search", "lead_id",
];

// The provider outcomes the digest counts as a failed delivery.
export const DELIVERY_FAILURE_STATUSES = "bounced,dropped,spam,blocked";
export const MARKETING_CATEGORIES = "WORKFLOW,CAMPAIGN,FOLLOW_UP";

export const STATUS_PRESETS = [
  { value: DELIVERY_FAILURE_STATUSES, label: "Any delivery failure" },
];
export const CATEGORY_PRESETS = [
  { value: MARKETING_CATEGORIES, label: "All marketing" },
];

export function defaultActivityFilters(today, weekAgo) {
  return {
    date_from: weekAgo, date_to: today, workflow_id: "", campaign_id: "",
    step_index: "", status: "", category: "all", search: "", lead_id: "",
  };
}

/** URL query -> filter state; missing keys take the defaults. */
export function activityFiltersFromSearch(search, defaults) {
  const p = new URLSearchParams(search || "");
  const f = { ...defaults };
  ACTIVITY_KEYS.forEach((k) => {
    const v = (p.get(k) || "").trim();
    if (v) f[k] = v;
  });
  return f;
}

/** Filter state -> URLSearchParams (empty values dropped). */
export function searchFromActivityFilters(f) {
  const p = new URLSearchParams();
  ACTIVITY_KEYS.forEach((k) => {
    const v = f?.[k];
    if (v) p.set(k, v);
  });
  return p;
}

/**
 * Options for a <select>: presets first, then the server's values; a
 * current value that is neither is still listed (labelled raw), so the
 * control never silently shows "All" for a filter that is applied.
 */
export function selectOptions(current, presets, values, labelFor) {
  const out = presets.map((p) => ({ value: p.value, label: p.label }));
  (values || []).forEach((v) => {
    if (!out.some((o) => o.value === v)) out.push({ value: v, label: labelFor ? labelFor(v) : v });
  });
  if (current && current !== "all" && !out.some((o) => o.value === current)) {
    out.push({ value: current, label: current.split(",").map((v) => (labelFor ? labelFor(v) : v)).join(" + ") });
  }
  return out;
}
